const path = '/assets';

export const ICONS = {
    'ic-note': `${path}/icons/ic-note.svg`,
    'ic-list': `${path}/icons/ic-list.svg`,
    'ic-heart-simple': `${path}/icons/ic-heart-simple.svg`,
    'ic-circle-check-white': `${path}/icons/ic-circle-check-white.svg`,
    'ic-close-gray': `${path}/icons/ic_close_gray.svg`,
    'ic-warn-fill': `${path}/icons/ic-warn-fill.svg`,
    'ic-wifi': `${path}/icons/ic_wifi.svg`,
    'ic-rounded-check': `${path}/icons/ic-rounded-check.svg`,
    'ic-edit-image': `${path}/icons/ic-edit-image.svg`,
    'ic-fb': `${path}/icons/ic-fb.svg`,
    'ic-pin': `${path}/icons/ic-pin.svg`,
    'ic-man': `${path}/icons/ic-man.svg`,
    'ic-add': `${path}/icons/ic-add.svg`,
    'ic-date': `${path}/icons/ic-date.svg`,
    'ic-cart': `${path}/icons/ic-cart.svg`,
    'ic-menu-dept': `${path}/icons/ic-menu-dept.svg`,
    'ic-time': `${path}/icons/ic-time.svg`,
    'ic-next': `${path}/icons/ic-next.svg`,
    'ic-plus': `${path}/icons/ic-plus.svg`,
    'ic-mail': `${path}/icons/ic-mail.svg`,
    'ic-talk': `${path}/icons/ic-talk.svg`,
    'ic-lock': `${path}/icons/ic-lock.svg`,
    'ic-visa': `${path}/icons/ic-visa.svg`,
    'ic-beer': `${path}/icons/ic-beer.svg`,
    'ic-meat': `${path}/icons/ic-meat.svg`,
    'ic-meds': `${path}/icons/ic-meds.svg`,
    'ic-pets': `${path}/icons/ic-pets.svg`,
    'ic-amex': `${path}/icons/ic-amex.svg`,
    'ic-play': `${path}/icons/ic-play.svg`,
    'ic-heart': `${path}/icons/ic-heart.svg`,
    'ic-women': `${path}/icons/ic-women.svg`,
    'ic-trash': `${path}/icons/ic-trash.svg?v=2`,
    'ic-house': `${path}/icons/ic-house.svg`,
    'ic-other': `${path}/icons/ic-other.svg`,
    'ic-minus': `${path}/icons/ic-minus.svg`,
    'ic-clock': `${path}/icons/ic-clock.svg`,
    'ic-check': `${path}/icons/ic-check.svg`,
    'ic-bread': `${path}/icons/ic-bread.svg`,
    'ic-fruit': `${path}/icons/ic-fruit.svg`,
    'ic-clear': `${path}/icons/ic-clear.svg`,
    'ic-change': `${path}/icons/ic-change.svg`,
    'ic-upload': `${path}/icons/ic-upload.svg`,
    'ic-google': `${path}/icons/ic-google.svg`,
    'ic-search': `${path}/icons/ic-search.svg`,
    'ic-ticket': `${path}/icons/ic-ticket.svg`,
    'ic-couple': `${path}/icons/ic-couple.svg`,
    'ic-office': `${path}/icons/ic-office.svg`,
    'ic-frozen': `${path}/icons/ic-frozen.svg`,
    'ic-pantry': `${path}/icons/ic-pantry.svg`,
    'ic-babies': `${path}/icons/ic-babies.svg`,
    'ic-picker': `${path}/icons/ic-picker.svg`,
    'ic-pickup': `${path}/icons/ic-pickup.svg`,
    'ic-filter': `${path}/icons/ic-filter.svg`,
    'ic-payment': `${path}/icons/ic-payment.svg`,
    'ic-address': `${path}/icons/ic-address.svg`,
    'ic-visible': `${path}/icons/ic-visible.svg`,
    'ic-note-on': `${path}/icons/ic-note-on.svg`,
    'ic-general': `${path}/icons/ic-general.svg`,
    'ic-pin-red': `${path}/icons/ic-pin-red.svg`,
    'ic-star-on': `${path}/icons/ic-star-on.svg`,
    'ic-favorite': `${path}/icons/ic-favorite.svg`,
    'ic-dropdown': `${path}/icons/ic-dropdown.svg`,
    'ic-document': `${path}/icons/ic-document.svg`,
    'ic-shipping': `${path}/icons/ic-shipping.svg`,
    'ic-earnings': `${path}/icons/ic-earnings.svg`,
    'ic-registro': `${path}/icons/ic-registro.svg`,
    'ic-fb-white': `${path}/icons/ic-fb-white.svg`,
    'ic-arrow-up': `${path}/icons/ic-arrow-up.svg`,
    'ic-note-off': `${path}/icons/ic-note-off.svg`,
    'ic-sections': `${path}/icons/ic-sections.svg`,
    'ic-heart-on': `${path}/icons/ic-heart-on.svg`,
    'ic-beverage': `${path}/icons/ic-beverage.svg`,
    'ic-prepared': `${path}/icons/ic-prepared.svg`,
    'ic-master-c': `${path}/icons/ic-master-c.svg`,
    'ic-star-off': `${path}/icons/ic-star-off.svg`,
    'ic-heart-off': `${path}/icons/ic-heart-off.svg`,
    'ic-bag-green': `${path}/icons/ic-bag-green.svg`,
    'ic-man-green': `${path}/icons/ic-man-green.svg`,
    'ic-share-off': `${path}/icons/ic-share-off.svg`,
    'ic-detergent': `${path}/icons/ic-detergent.svg`,
    'ic-radio-off': `${path}/icons/ic-radio-off.svg`,
    'ic-plus-white': `${path}/icons/ic-plus-white.svg`,
    'ic-arrow-down': `${path}/icons/ic-arrow-down.svg`,
    'ic-mastercard': `${path}/icons/ic-mastercard.svg`,
    'ic-dairy-eggs': `${path}/icons/ic-dairy-eggs.svg`,
    'ic-time-gears': `${path}/icons/ic-time-gears.svg`,
    'ic-yt-white': `${path}/icons/ic-youtube-white.svg`,
    'ic-menu-mobile': `${path}/icons/ic-menu-mobile.svg`,
    'ic-wa-white': `${path}/icons/ic-whatsapp-white.svg`,
    'ic-wa-green': `${path}/icons/ic-whatsapp-green.svg`,
    'ic-visible-off': `${path}/icons/ic-visible-off.svg`,
    'ic-close-green': `${path}/icons/ic-close-green.svg`,
    'ic-ig-white': `${path}/icons/ic-instagram-white.svg`,
    'ic-not-favorite': `${path}/icons/ic-not-favorite.svg`,
    'ic-delicatessen': `${path}/icons/ic-delicatessen.svg`,
    'ic-shipping-red': `${path}/icons/ic-shipping-red.svg`,
    'ic-profile-user': `${path}/icons/ic-profile-user.svg`,
    'ic-tracking-store': `${path}/images/tracking-store.svg`,
    'ic-visible-green': `${path}/icons/ic-visible-green.svg`,
    'ic-step-received': `${path}/icons/ic-step-received.svg`,
    'ic-tooltip-error': `${path}/icons/ic-tooltip-error.svg`,
    'ic-dropdown-green': `${path}/icons/ic-dropdown-green.svg`,
    'ic-document-green': `${path}/icons/ic-document-green.svg`,
    'ic-visible-off-green': `${path}/icons/ic-visible-off-green.svg`,
    'ic-personal-cleanliness': `${path}/icons/ic-personal-cleanliness.svg`,
    'ic-user-no-registered': `${path}/icons/ic-user-no-reg.svg`,
    'ic-user-registered': `${path}/icons/ic-user-reg.svg`,
    'ic-time-red': `${path}/icons/ic-header-shop-hrs.svg`,
    'ic-portions-red': `${path}/icons/ic-dark-porciones.svg`,
    'ic-facebook-white': `${path}/icons/ico-social-fb-2.svg`,
    'ic-check-on': `${path}/icons/ic-action-check-on.svg`,
    'ic-paypal': `${path}/icons/ic-paypal.svg`,
    'ic-on': `${path}/icons/ic-on.svg`,
    'ic-off': `${path}/icons/ic-off.svg`,
    'ic-search-green': `${path}/icons/ic-search-green.svg`,
    'ic-profile-pickup': `${path}/icons/ic-profile-pickup.svg`,
    'ic-edit': `${path}/icons/ic-edit.svg`,
    'ic-ball': `${path}/icons/ic-tracking-car-ball.svg`,
    'ic-help-gray': `${path}/icons/ic-help-grey.svg`,
    'ic-back-green': `${path}/icons/ic-back-green.svg`,
    'ic-right-green': `${path}/icons/ic-right-green.svg`,
    'ic-bag-green-shop': `${path}/icons/ic-shopping-bag-green.svg`,
    'ic-hours-green': `${path}/icons/ic-shop-hrs-green.svg`,
    'ic-money-green': `${path}/icons/ic-money-green.svg`,
    'ic-perfil-green': `${path}/icons/ic-perfil-on-green.svg`,
    'ic-food-white': `${path}/icons/ic-food-white.svg`,
    'ic-hour-white': `${path}/icons/ic-hour-white.svg`,
    'ic-checkbox-off': `${path}/icons/ic-checkbox-off.svg`,
    'ic-menu-grey': `${path}/icons/ic-menu-grey.svg`,
    'ic-basket': `${path}/icons/ic-basket.svg`,
    'face-green': `${path}/icons/face-green.svg`,
    'insta-green': `${path}/icons/insta-green.svg`,
    'youtube-green': `${path}/icons/youtube-green.svg`,
    'ic-ecovale': `${path}/icons/ic-ecovale.svg`,
    'ic-edenred': `${path}/icons/ic-edenred.svg`,
    'ic-efectivale': `${path}/icons/ic-efectivale.svg`,
    'ic-sivale': `${path}/icons/ic-sivale.svg`,
    'ic-sodexo': `${path}/icons/ic-sodexo.svg`,
    'ic-logo-alsuper.com': `${path}/icons/Alsuper.com.svg`,
    'ic-payment-against': `${path}/icons/ic-payment-against.svg`,
    'ic-icon-offer': `${path}/icons/ic-icon_offer.svg`,
    'ic-pad-error': `${path}/icons/ic-pad-error.svg`,
    'ic-lupa-in': `${path}/icons/ic-lupa-in.svg`,
    'ic-lupa-out': `${path}/icons/ic-lupa-out.svg`,
    'ic-alsuper': `${path}/icons/Alsuper.svg`,
    'ic-bxs-truck': `${path}/icons/ic-bxs-truck.svg`,
    'ic-close-white': `${path}/icons/ic-close-white.svg`,
    'ic-error-exc': `${path}/icons/ic-error-exc.svg`,
    'ic-info-blue': `${path}/icons/ic-info-blue.svg`,
    'ic-delivery-color': `${path}/icons/ic-delivery-color.svg`,
    'ic-help-white': `${path}/icons/ic-help-white.svg`,
    'ic-alert': `${path}/icons/ic-alert.svg`,
    'ic-check-data': `${path}/icons/ic-check-data.svg`,
    'ic-info-security': `${path}/icons/ic-info-security.svg`,
    'ic-orange-alert': `${path}/icons/ic-orange-alert.svg`,
    'ic-express': `${path}/icons/ic-express.svg`,
    'ic-minus-white': `${path}/icons/ic-minus-white.svg`,
    'ic-club-alsuper-logo': `${path}/icons/club-alsuper-logo.svg`,
    'ic-arrow-right': `${path}/icons/ic-arrow-right.svg`,
    'ic-information-blue': `${path}/icons/ic-information-blue.svg`,
    'ic-question': `${path}/icons/ic-question.svg`,
    'ic-green-checkmark': `${path}/icons/ic-green-checkmark.svg`,
    'ic-warning-alert': `${path}/icons/ic-warning-alert.svg`,
    'ic-alsuper-blue': `${path}/icons/ic-alsuper-blue.svg`,
    'ic-alsuper-red': `${path}/icons/ic-alsuper-red.svg`,
    'ic-alsuper-green': `${path}/icons/ic-alsuper-green.svg`,
    'ic-alert-change-password': `${path}/icons/ic-alert-change-password.svg`,
    'ic-order': `${path}/icons/ic-order.svg`,
    'ic-location-green': `${path}/icons/ic-location-green.svg`,
    'ic-edit-green': `${path}/icons/ic-edit-green.svg`,
    'ic-help-green': `${path}/icons/ic-help-green.svg`,
    'ic-express-red': `${path}/icons/ic-express-red.svg`,
    'ic-plus-green': `${path}/icons/ic-plus-green.svg`,
    'ic-alsuper-white': `${path}/icons/ic-alsuper-white.svg`,
    'ic-visa-white': `${path}/icons/ic-visa-white.svg`,
    'ic-amex-blue': `${path}/icons/ic-amex-blue.svg`,
    'ic-mastercard-footer': `${path}/icons/ic-mastercard-footer.svg`,
    'ic-info-outline': `${path}/icons/ic-info-outline.svg`,
    'ic-sort': `${path}/icons/ic-sort.svg`,
    'ic-filter-dept': `${path}/icons/ic-filter-dept.svg`,
    'ic-help-menu': `${path}/icons/ic-help-menu.svg`,
    'ic-lists-menu': `${path}/icons/ic-lists-menu.svg`,
    'ic-offers': `${path}/icons/ic-offers.svg`,
    'ic-arrow-right-grey': `${path}/icons/ic-arrow-right-grey.svg`,
    'ic-departments': `${path}/icons/ic-departments.svg`,
    'ic-arrow-left': `${path}/icons/ic-arrow-left.svg`,
    'ic-close-sesion': `${path}/icons/ic-close-sesion.svg`,
    'ic-account': `${path}/icons/ic-account.svg`,
    'ic-purchases': `${path}/icons/ic-purchases.svg`,
    'ic-payment-methods': `${path}/icons/ic-payment-methods.svg`,
    'ic-addresses': `${path}/icons/ic-addresses.svg`,
    'ic-preferences': `${path}/icons/ic-preferences.svg`
};
